<template>
  <div class="basicStyle">
     <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>标题</span>
          <el-input
            v-model="queryInfo.title"
            clearable
            size="small"
            placeholder="请输入标题"
          ></el-input>
        </div> 
        <div class="searchItem">
          <span>分类</span>
          <el-select
            v-model="queryInfo.type_id"
            filterable
            placeholder="请选择分类"
            :clearable="false"
            size="mini"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="searchItem" style="margin-left: 20px;">
          <el-select
            v-model="queryInfo.time_type_id"
            filterable
            placeholder="请选择搜时间类型"
            :clearable="false"
            size="mini"
            style="margin-right: 20px;"
          >
            <el-option
              v-for="item in timeTypeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- <span>创建时间：</span> -->
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>状态</span>
          <el-select
            v-model="queryInfo.view_status"
            filterable
            placeholder="请选择状态"
            :clearable="false"
            size="mini"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <MyButton
            value="搜索"
            size="medium"
            icon="el-icon-search"
            type="1"
            @click="queryTable('search')"
          ></MyButton>
          <MyButton
            value="重置"
            size="medium"
            type="2"
            @click="resetQuery"
          ></MyButton>
        </div>
      </div>

      <div>
        <div class="table">
          <TableComponents :columns="columns" :tableData="tableList">
            <template slot="operation" slot-scope="{ row }">
              <el-button
                type="warning"
                size="mini"
                @click="viewDetail(row)"
                >查看</el-button
              >
            </template>
          </TableComponents>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfo.page"
              :page-sizes="[10, 30, 50, 80]"
              :page-size="queryInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>  
  </template> 
  <script>
  import commonApi from "@/api/common"; 
  import TableComponents from "@/components/TableComponents.vue";
  import { clearObj, copyToClip } from "@/utils/index.js";
  import { deepClone } from "@/utils"; 
  import MyButton from "@/components/MyButton.vue";
  export default {
    name: "noticeList", //公告列表
    components: {
      TableComponents,
      MyButton,
    },
    data() {
      return {
        queryInfo: {
            limit: 10,
            page: 1,
            total: 0, 
            type_id:0,
            view_status:0,
            time_type_id:2,
        },
        columns: [
            //列数据
            { label: "ID", prop: "id" },
            { label: "标题", prop: "title" },
            { label: "分类", prop: "type_name" },
            { label: "发布时间", prop: "push_date" },
            { label: "状态", prop: "view_status_name" },
            { label: "操作", prop: "operation" },
        ],
        tableList: [],
        statusOptions: [
            //开卡状态：-1全部 0创建中 1开始导出 2导出完成 
        ],
        typeOptions: [],
        timeFrame: [],
        timeTypeOptions: [],
      };
    },
    computed: { 

    },
    watch: {
       
    },
    created() {
        this.queryTable();
    },
    methods: { 
    // 选择日期
        selectData(e) {
          if (e) {
            this.queryInfo.start_date = e[0];
            this.queryInfo.end_date = e[1];
          } else {
            this.queryInfo.start_date = "";
            this.queryInfo.end_date = "";
          }
        },
        viewDetail(e) {
            console.log("viewDetail",e)
            this.$router.push({
              path: "/noticeDetail",
              query: {
                id: e.id,
              },
            });
        },
        // 列表数据
        async queryTable(_type) {
            if (_type) {
                this.queryInfo.page = 1;
            }
            const res = await commonApi.getNoticeList(this.queryInfo);
            if (res.code == 200) {
                this.queryInfo.total = res.data.total;
                this.tableList = res.data.list;

                this.statusOptions = res.data.view_status_list;
                this.typeOptions = res.data.type_list;
                this.timeTypeOptions = res.data.time_type_list;
                
            } else {
                this.$message.error(res.message);
            }
        },
        // 重置
        resetQuery() {
            this.timeFrame = [];
            this.queryInfo = {
                limit: 10,
                page: 1,
                total: 0,  
                type_id:0,
                view_status:0,
                time_type_id:2,
            };
            this.queryTable();
        },
        // 分页
        handleSizeChange(e) {
            this.queryInfo.limit = e;
            this.queryTable();
        },
        handleCurrentChange(e) {
            this.queryInfo.page = e;
            this.queryTable();
        },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .basicStyle {
    span {
      display: inline-block;
    }
    .querySearch {
      .searchItem {
        display: inline-block;
        padding: 5px 0;
        margin-right: 30px;
        span {
          margin-right: 10px;
          font-size: 14px;
        }
        /deep/ .el-input {
          width: 250px;
          padding: 5px 0;
        }
      }
      /deep/ .el-button--primary {
        // margin-left: 50px;
      }
    }
    .addInfo {
      margin: 10px 0 20px 0;
    }
  
    // 表格数据
    .table {
      min-height: calc(100vh - 330px);
    } 
  
    // 分页
    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px;
    }
  
    /deep/ .formDialog {
      .courseDetail {
        img {
          width: 200px;
        }
        .couseUl {
          text-decoration: none;
          height: 400px;
          overflow: auto;
          margin-top: 20px;
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .sellPriceType {
            background-color: rgb(89, 89, 246);
            color: #fff;
            margin: 0 25px;
            width: 100px;
            text-align: center;
            border-radius: 10px;
          }
        }
      }
      .userInfoFormStyle {
        display: flex;
        line-height: 40px;
        margin-bottom: 15px;
        .t1 {
          padding: 0 12px 0 0;
          width: 100px;
          box-sizing: border-box;
          text-align: right;
        }
        .t2 {
        }
        .t3 {
        }
      }
      .userInfoFormStyle-price {
        display: flex;
        line-height: 40px;
        margin-bottom: 15px;
        justify-content: start;
        padding: 0 20px;
        .userInfoFormStyle-price-item {
          width: 50%;
        }
      }
      .el-select .el-input {
        width: 180px;
      }
      .el-input {
        width: 250px;
      }
      .dialog-footer {
        text-align: center;
      }
      .roleStyle {
        .el-form-item__content {
          display: flex;
          align-items: center;
          .el-form-item__content {
            margin-left: 0 !important;
          }
          img {
            width: 20px;
            height: 20px;
            margin-left: 10px;
            cursor: pointer;
          }
          .el-button {
            border: none;
            padding-left: 5px;
          }
          .el-button:focus,
          .el-button:hover {
            background-color: #fff;
          }
        }
      }
    }
  }
  
  .teach-extend-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .teach-extend-box-tc {
      color: #d9001b;
    }
  }
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield !important;
  }
  /deep/ .el-input-group__append,
  .el-input-group__prepend {
    background-color: #409eff;
    color: #fff;
    border: 1px solid #409eff;
  }
  /deep/.el-tree-node__content {
    display: flex;
    align-items: center;
    height: 40px;
    cursor: pointer;
    padding-right: 15px;
  }
  </style>
  